import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

export const SkeletonRow = () => (
    <TableRow>
        <TableCell className="p-4"><Skeleton className="h-4 w-4" /></TableCell>
        <TableCell className="p-4"><Skeleton className="h-4 w-48" /></TableCell>
        <TableCell className="p-4"><Skeleton className="h-4 w-32" /></TableCell>
        <TableCell className="p-4"><Skeleton className="h-4 w-24" /></TableCell>
        <TableCell className="p-4">
            <div className="flex items-center justify-end gap-2">
                <Skeleton className="h-9 w-20 rounded-md" />
                <Skeleton className="h-9 w-9 rounded-md" />
            </div>
        </TableCell>
    </TableRow>
);